module.exports = __webpack_public_path__ + "img/suitcase.e482436b.svg";